import { Link, Route, Switch, useLocation, useParams, Redirect } from "wouter";
import { Receipt, Inbox, FileText } from "lucide-react";
import { TodayBillingDay } from "@/components/billing/today-billing-day";
import { InvoiceQueue } from "@/components/billing/invoice-queue";
import { ChargesInbox } from "@/components/billing/charges-inbox";
import { MemberLedgerDrilldown } from "@/components/billing/member-ledger-drilldown";
import { SchedulerStatusDot } from "@/components/billing/scheduler-status-dot";

const NAV = [
  { name: "Today's Billing", href: "/billing/today",    icon: Receipt },
  { name: "Invoice Queue",   href: "/billing/invoices", icon: FileText },
  { name: "Charges Inbox",   href: "/billing/charges",  icon: Inbox },
];

function LedgerRoute() {
  const params = useParams<{ memberId: string }>();
  const id = Number(params.memberId);
  if (!Number.isFinite(id)) return <div>Invalid member id</div>;
  return <MemberLedgerDrilldown memberId={id} />;
}

export default function Billing() {
  const [location] = useLocation();

  return (
    <div className="flex h-full">
      <aside className="w-56 shrink-0 border-r bg-sidebar flex flex-col">
        <div className="px-4 py-4 text-lg font-semibold">Billing</div>
        <nav className="flex-1 space-y-1 px-2">
          {NAV.map((item) => {
            const active = location.startsWith(item.href);
            const Icon = item.icon;
            return (
              <Link
                key={item.href}
                href={item.href}
                className={`flex items-center h-11 px-3 rounded-md text-sm font-semibold ${
                  active
                    ? "bg-sidebar-primary text-sidebar-primary-foreground"
                    : "text-sidebar-foreground hover:bg-sidebar-accent"
                }`}
              >
                <Icon className="mr-2 h-4 w-4" />
                {item.name}
              </Link>
            );
          })}
        </nav>
        <div className="border-t p-4">
          <SchedulerStatusDot lastTick={null} />
        </div>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Switch>
          <Route path="/billing/today"           component={TodayBillingDay} />
          <Route path="/billing/invoices"        component={InvoiceQueue} />
          <Route path="/billing/charges"         component={ChargesInbox} />
          <Route path="/billing/ledger/:memberId" component={LedgerRoute} />
          <Route path="/billing">{() => <Redirect to="/billing/today" />}</Route>
        </Switch>
      </main>
    </div>
  );
}
